var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-wrapper container-xxl p-0" },
    [
      _c("div", { staticClass: "content-header row" }),
      _c("div", { staticClass: "content-body" }, [
        _c("p", { staticClass: "mb-2" }, [
          _vm._v(
            " A role gives users access to specified menus and functions, allowing administrators to access the features they require based on the role they have been allocated. "
          ),
        ]),
        _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _vm.loading
              ? _c("b-spinner", {
                  staticStyle: { width: "3rem", height: "3rem" },
                  attrs: { variant: "success", label: "Spinning" },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "col-xl-4 col-lg-6 col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "card-body text-sm-end text-center ps-sm-0",
                      },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.modal-add",
                                modifiers: { "modal-add": true },
                              },
                            ],
                            staticClass:
                              "stretched-link text-nowrap add-new-role",
                            attrs: { href: "javascript:void(0)" },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "btn btn-primary mb-3" },
                              [_vm._v("Add New Role")]
                            ),
                          ]
                        ),
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v("Add role, if it does not exist"),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._l(_vm.role, function (item) {
              return _c(
                "div",
                { key: item, staticClass: "col-xl-4 col-lg-6 col-md-6" },
                [
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-end mt-1 pt-25",
                        },
                        [
                          _c("div", { staticClass: "role-heading" }, [
                            _c("h4", { staticClass: "fw-bolder" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                            _c("p", { staticClass: "fw-bolder" }, [
                              _vm._v(_vm._s(item.description)),
                            ]),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.modal-edit",
                                    modifiers: { "modal-edit": true },
                                  },
                                ],
                                staticClass: "role-edit-modal",
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function ($event) {
                                    return _vm.sendInfo(item)
                                  },
                                },
                              },
                              [
                                _c("small", { staticClass: "fw-bolder" }, [
                                  _vm._v("Edit Role"),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._m(0, true),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-add",
            "ok-only": "",
            "ok-title": "Accept",
            centered: "",
            size: "lg",
            title: "Add new role",
            "hide-footer": "true",
          },
          on: { hidden: _vm.resetModal },
        },
        [
          _c("div", { staticClass: "modal-body px-5 pb-5" }, [
            _c("div", { staticClass: "text-center mb-4" }, [
              _c("h1", { staticClass: "role-title" }, [_vm._v("Add New Role")]),
            ]),
            _c(
              "form",
              {
                staticClass: "row",
                attrs: { id: "addRoleForm" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.addRole()
                  },
                },
              },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "modalRoleName" },
                    },
                    [_vm._v("Role Name")]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.AddName,
                        expression: "AddName",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "modalRoleName",
                      name: "modalRoleName",
                      required: "",
                      placeholder: "Enter role name",
                    },
                    domProps: { value: _vm.AddName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.AddName = $event.target.value
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "col-12 my-1" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "modalRoleName" },
                      },
                      [_vm._v("Description")]
                    ),
                    _c("b-form-textarea", {
                      attrs: {
                        id: "textarea-default",
                        placeholder: "Description",
                        rows: "3",
                        required: "",
                      },
                      model: {
                        value: _vm.AddDescription,
                        callback: function ($$v) {
                          _vm.AddDescription = $$v
                        },
                        expression: "AddDescription",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 text-center mt-2 d-flex justify-content-between",
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-primary me-1",
                        attrs: { type: "submit" },
                      },
                      [
                        _vm.loading
                          ? _c("b-spinner", { attrs: { small: "" } })
                          : _vm._e(),
                        _vm._v("Add Role"),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-edit",
            "ok-only": "",
            "ok-title": "Accept",
            centered: "",
            size: "lg",
            title: "Edit role",
            "hide-footer": "true",
          },
          on: { hidden: _vm.handleModalClose },
        },
        [
          _c("div", { staticClass: "modal-body px-5 pb-5" }, [
            _c("div", { staticClass: "text-center mb-4" }, [
              _c("h1", { staticClass: "role-title" }, [
                _vm._v("Edit this role"),
              ]),
              _c("p", [_vm._v("Edit / Set role permissions")]),
            ]),
            _c(
              "form",
              {
                staticClass: "row",
                attrs: { id: "editRoleForm" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.updateRole()
                  },
                },
              },
              [
                _c("div", { staticClass: "col-12 my-1" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "modalRoleName" },
                    },
                    [_vm._v("Role Name")]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedRole.name,
                        expression: "selectedRole.name",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "modalRoleName",
                      name: "modalRoleName",
                      placeholder: "Enter role name",
                      required: "",
                    },
                    domProps: { value: _vm.selectedRole.name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.selectedRole, "name", $event.target.value)
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "col-12 my-1" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "modalRoleName" },
                      },
                      [_vm._v("Description")]
                    ),
                    _c("b-form-textarea", {
                      attrs: {
                        id: "textarea-default",
                        placeholder: "Description",
                        rows: "3",
                        required: "",
                      },
                      model: {
                        value: _vm.selectedRole.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.selectedRole, "description", $$v)
                        },
                        expression: "selectedRole.description",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 my-1" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "danger" },
                        on: {
                          click: function ($event) {
                            return _vm.removeRole(_vm.selectedRole.id)
                          },
                        },
                      },
                      [
                        _vm.loading
                          ? _c("b-spinner", { attrs: { small: "" } })
                          : _vm._e(),
                        _vm._v("Delete Role "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "col-12" }, [
                  _c("h4", { staticClass: "mt-2 pt-50" }, [
                    _vm._v("Role Permissions"),
                  ]),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", { staticClass: "table table-flush-spacing" }, [
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _c("td", { staticClass: "text-nowrap fw-bolder" }, [
                              _vm._v(" Administrator Access "),
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-bs-toggle": "tooltip",
                                    "data-bs-placement": "top",
                                    title: "Allows a full access to the system",
                                  },
                                },
                                [_c("i", { attrs: { "data-feather": "info" } })]
                              ),
                            ]),
                            _c("td", [
                              _c("div", { staticClass: "form-check" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectAllData,
                                      expression: "selectAllData",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: { type: "checkbox", id: "selectAll" },
                                  domProps: {
                                    checked: Array.isArray(_vm.selectAllData)
                                      ? _vm._i(_vm.selectAllData, null) > -1
                                      : _vm.selectAllData,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = _vm.selectAllData,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectAllData = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectAllData = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectAllData = $$c
                                        }
                                      },
                                      function ($event) {
                                        return _vm.selectAllFunction(
                                          _vm.selectAllData
                                        )
                                      },
                                    ],
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: "selectAll" },
                                  },
                                  [_vm._v(" Select All ")]
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._l(
                            _vm.permissionsPersonal,
                            function (permission) {
                              return _c("tr", { key: permission.value }, [
                                _c(
                                  "td",
                                  { staticClass: "text-nowrap fw-bolder" },
                                  [_vm._v(_vm._s(permission))]
                                ),
                                _c("td", [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-check me-3 me-lg-5",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedPermissions,
                                              expression: "selectedPermissions",
                                            },
                                          ],
                                          staticClass: "form-check-input",
                                          attrs: {
                                            type: "checkbox",
                                            id: permission,
                                          },
                                          domProps: {
                                            value: permission,
                                            checked: Array.isArray(
                                              _vm.selectedPermissions
                                            )
                                              ? _vm._i(
                                                  _vm.selectedPermissions,
                                                  permission
                                                ) > -1
                                              : _vm.selectedPermissions,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.selectedPermissions,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = permission,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedPermissions =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedPermissions =
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                }
                                              } else {
                                                _vm.selectedPermissions = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "form-check-label",
                                            attrs: { for: permission },
                                          },
                                          [_vm._v(" Grant ")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ])
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 text-center mt-2 d-flex justify-content-between",
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-primary me-1",
                        attrs: { type: "submit" },
                      },
                      [
                        _vm.loading
                          ? _c("b-spinner", { attrs: { small: "" } })
                          : _vm._e(),
                        _vm._v("Edit Role"),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "text-body", attrs: { href: "javascript:void(0);" } },
      [
        _c("i", {
          staticClass: "font-medium-5",
          attrs: { "data-feather": "copy" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }